import { isNil } from 'lodash'

import TypeVariation from '#/components/FormatCell/Types/Variation'
import { resolveValueColor } from '#/components/FormatCell/Types/Variation/Logic/colors'
import { TypeVariationProps } from '#/components/FormatCell/Types/Variation/types'
import { OutdatedData } from '#/components/OutdatedData'

export interface TypeOutdatedVariationProps extends Omit<TypeVariationProps, 'tooltip'> {
  /** Data da leitura que gerou o valor; define asterisco ou ocultação por dado desatualizado. */
  timestamp?: string
}

const TypeOutdatedVariation = ({ timestamp, ...variationProps }: TypeOutdatedVariationProps) => {
  if (isNil(variationProps.value) || variationProps.hideIf) {
    return <TypeVariation {...variationProps} />
  }

  return (
    <OutdatedData timestamp={timestamp} style={{ color: resolveValueColor(variationProps) }}>
      <TypeVariation {...variationProps} />
    </OutdatedData>
  )
}

export default TypeOutdatedVariation
